import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleParagraph extends ToolToggleBlock {
  static toolName = 'Paragraph';
  static iconClass = 'fa-regular fa-paragraph';
  static blockType = 'paragraph';
  static shortcut = 'Cmd+Option+0';
}

export default ToolToggleParagraph;
